import { Autocomplete, Box, TextField } from "@mui/material";
import { red } from "@mui/material/colors";
import React, { useEffect, useRef } from "react";
import { getAllClients } from "services/userServices";
import PropTypes from "prop-types";
export default function ClientAutoComplete(props) {
  const [clients, setClients] = React.useState([]);
  const [selectedClient, setSelectedClient] = React.useState(null);

  const { onChange, required, setLoading, onLoadValue } = props;
  // Ensures the onLoadValue -> onChange hydration only ever fires once,
  // so it can't re-emit a fresh selectedClient reference later and clobber
  // a value the user (or a consuming component) has since changed.
  const hasHydratedRef = useRef(false);
  useEffect(() => {
    let cancelled = false;

    const fetchData = async () => {
      if (!cancelled) {
        setLoading(true);
      }

      try {
        const response = await getAllClients();

        if (cancelled) return;

        if (response.message === "Success") {
          if (!cancelled) {
            setClients(response.data);
          }
        }
      } catch (error) {
        if (!cancelled) {
          console.error("Failed to fetch clients:", error);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    fetchData();

    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (hasHydratedRef.current) return;
    if (!onLoadValue || clients.length === 0) return;

    const selectedClient = clients.find(
      (client) => client.ClientName === onLoadValue,
    );
    if (selectedClient) {
      setSelectedClient(selectedClient);
      onChange(selectedClient);
      hasHydratedRef.current = true;
    }
  }, [clients, onLoadValue]);

  const handleChange = (event, newValue) => {
    setSelectedClient(newValue);
    onChange(newValue);
  };

  return (
    <Autocomplete
      options={clients}
      value={selectedClient}
      onChange={handleChange}
      getOptionLabel={(option) =>
        option.ClientName ? `${option.ClientName} (${option.ClientCode})` : ""
      }
      sx={{ width: "100%" }}
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          label={
            required ? (
              <Box>
                Client&nbsp;
                <Box component="span" sx={{ color: red[700] }}>
                  *
                </Box>
              </Box>
            ) : (
              "Client"
            )
          }
          variant="outlined"
          sx={{ backgroundColor: "#fff" }}
        />
      )}
    />
  );
}
ClientAutoComplete.propTypes = {
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  setLoading: PropTypes.func.isRequired,
  onLoadValue: PropTypes.string,
};
